<!-- =========================================================================================
  File Name: UserList.vue
  Description: Dashboard List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <div class="vx-row p-4" style="float:right!important;">
        <div class="vx-col-12" style="float:right!important;">
          <vs-button color="primary" style="float:right!important;"  type="filled" icon-pack="feather" icon="icon-plus-circle" @click="addDashboardPopUpActive = true">{{ $t('DASHBOARD.Add') }}</vs-button>
        </div>
      </div>
      <br><br><br>
      <!-- <ADICIONAR DASHBOARD> -->
      <vs-popup :title="`${$t('DASHBOARD.Add')} Dashboard`" :active.sync="addDashboardPopUpActive">
        <div class="vx-row" id="add-dashboard">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Name')" v-model="addDashboardData.name" class="w-full" type="text" name="dashboard-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Description')" v-model="addDashboardData.description" class="w-full" type="text" name="dashboard-description"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">{{ $t('DASHBOARD.Roles') }}</label>
            <v-select multiple label="name" :closeOnSelect="false" v-model="addDashboardData.roles" :options="rolesOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">Intervalo de atualização</label>
            <v-select label="name" v-model="addDashboardData.refreshInterval" :clearable="false" :options="refreshIntervalOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
        </div>
        <br><br><br><br><br>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-button class="ml-auto mt-2" @click="addDashboard">Enviar</vs-button>
          </div>
        </div>
      </vs-popup>
      <!-- </ADICIONAR DASHBOARD> -->
      <!-- <VISUALIZAR DASHOBARD> -->
      <vs-popup :title="$t('DASHBOARD.ViewDashboard')" :active.sync="viewDashboardPopUpActive">
        <div class="vx-row" id="add-dashboard">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Name')" disabled v-model="viewDashboardData.name" class="w-full" type="text" name="dashboard-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Description')" disabled v-model="viewDashboardData.description" class="w-full" type="text" name="dashboard-description"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">{{ $t('DASHBOARD.Roles') }}</label>
            <v-select multiple label="name" :closeOnSelect="false" disabled v-model="viewDashboardData.roles" :options="allRolesOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">{{ $t('DASHBOARD.RefreshInterval') }}</label>
            <v-select label="name" disabled v-model="viewDashboardData.refreshInterval" :clearable="false" :options="refreshIntervalOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
        </div>
      </vs-popup>
      <!-- </VISUALIZAR DASHBOARD> -->
      <!-- <EDITAR DASHBOARD> -->
      <vs-popup :title="$t('EditDashboard')" :active.sync="editDashboardPopUpActive">
        <div class="vx-row" id="add-dashboard">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Name')" v-model="editDashboardData.name" class="w-full" type="text" name="dashboard-name"/>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-input :label="$t('DASHBOARD.Description')" v-model="editDashboardData.description" class="w-full" type="text" name="dashboard-description"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">{{ $t('DASHBOARD.Roles') }}</label>
            <v-select multiple label="name" :closeOnSelect="false" v-model="editDashboardData.roles" :options="allRolesOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <label class="vs-input--label">{{ $t('DASHBOARD.RefreshInterval') }}</label>
            <v-select label="name" v-model="editDashboardData.refreshInterval" :clearable="false" :options="refreshIntervalOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
          </div>
        </div>
        <br><br><br><br><br>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-2 mb-3">
            <vs-button class="ml-auto mt-2" @click="updateDashboard">{{ $t('DASHBOARD.Sent') }}</vs-button>
          </div>
        </div>
      </vs-popup>
      <!-- </EDITAR DASHBBOARD> -->
      <div class="vx-card p-6">
        <vs-table
          multiple
          v-model="selectedRows"
          :sst="false"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          pagination
          max-items="10"
          search
          :data="dashboards">

            <template slot="header">
                <h3>{{ $t('TITLE.DashboardManagement') }}</h3>
            </template>

            <template slot="thead">
              <vs-th sort-key="hash">{{ $t('DASHBOARD.Hash') }}</vs-th>
              <vs-th sort-key="name">{{ $t('DASHBOARD.Name') }}</vs-th>
              <vs-th sort-key="description">{{ $t('DASHBOARD.Description') }}</vs-th>
              <vs-th sort-key="refreshInterval">{{ $t('DASHBOARD.RefreshInterval') }}</vs-th>
              <vs-th sort-key="actions">{{ $t('DASHBOARD.Actions') }}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].hash">
                  {{ data[indextr].hash }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].description">
                  {{ data[indextr].description }}
                </vs-td>

                <vs-td :data="data[indextr].refreshInterval">
                  {{ data[indextr].refreshInterval }}
                </vs-td>

                <vs-td>
                  <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" @click="viewDashboardDetail(data[indextr]['hash'])"/>
                  <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="getDashboardDetail(data[indextr]['hash'])"/>
                  <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr]['hash'])"/>
                </vs-td>
              </vs-tr>
            </template>
        </vs-table>
      </div>
  </div>
</template>

<script>
import StringMask from 'string-mask'
import vSelect from 'vue-select'
import { setApplicationLocalStorageItem } from '../../../helpers'
import { performFetch } from '../../../helpers.js'
export default {
  components: {
    vSelect
  },
  data:() => ({
    moduleInfo: {
      moduleName: ''
    },
    rowHashToDelete: '',
    refreshIntervalOptions: [
      {
        value: 30,
        name: '30 segundos'
      },
      {
        value: 60,
        name: '1 minuto'
      },
      {
        value: 300,
        name: '5 minutos'
      }
    ],
    addDashboardPopUpActive: false,
    viewDashboardPopUpActive: false,
    editDashboardPopUpActive: false,

    addDashboardData: {
      name: '',
      description: '',
      refreshInterval: {value: 30, name: '30 segundos'},
      roles: []
    },
    editDashboardData: {
      hash: '',
      name: '',
      description: '',
      refreshInterval: {value: 30, name: '30 segundos'},
      roles: []
    },
    viewDashboardData: {
      name: '',
      description: '',
      refreshInterval: 0,
      roles: []
    },
    rolesOptions: [],
    allRolesOptions: [],


    selected:[],
    log: [],
    dashboards: [],
    tableTitles: [],
    selectedRows: [],
    rowHashToDelete: ''
  }),
  watch: {
    selectedRows (value) {
      // console.log(value)
    },
    'addDashboardData.roles' (newValue) {
      const mergedRolesOptions = JSON.parse(JSON.stringify(this.allRolesOptions))

      if (newValue.length > 0) {
        newValue.forEach(item => {
          const index = mergedRolesOptions.findIndex(x => x.hash === item.hash)
          if (index > -1) {
            mergedRolesOptions.splice(index, 1)
          }
        })
      }

      this.rolesOptions = mergedRolesOptions
    },
    addDashboardPopUpActive (newValue) {
      if (!newValue) {
        this.clearAddForm()
      }
    },
    editDashboardPopUpActive (newValue) {
      if (!newValue) {
        this.clearEditForm()
      }
    }
  },
  mounted () {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]  } | Dashboard`
  },
  methods:{
    handleSearch (searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage (page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort (key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    clearAddForm () {
      this.addDashboardData.name = ''
      this.addDashboardData.description = ''
      this.addDashboardData.refreshInterval = {value: 30, name: '30 segundos'}
      this.addDashboardDataroles = []
    },
    clearEditForm () {
      this.editDashboardData.name = ''
      this.editDashboardData.description = ''
      this.editDashboardData.refreshInterval = {value: 30, name: '30 segundos'}
      this.editDashboardData.roles = []
    },
    validateAddForm () {
      if (this.addDashboardData.name === '' || this.addDashboardData.name === null) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Nome do Dashboard é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (Array.isArray(this.addDashboardData.roles) && this.addDashboardData.roles.length === 0) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Cargos com permissão é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (Array.isArray(this.addDashboardData.refreshInterval) && this.addDashboardData.refreshInterval.length === 0) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'O campo Intervalo de Atualização é obrigatório!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateEditForm () {
      if (this.editDashboardData.name === '' || this.editDashboardData.name === null) {
        this.$vs.notify({
          title: this.$t('DASHBOARD.Attention'),
          text: this.$t('DASHBOARD.RequiredNameField'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (Array.isArray(this.editDashboardData.roles) && this.editDashboardData.roles.length === 0) {
        this.$vs.notify({
          title: this.$t('DASHBOARD.Attention'),
          text: this.$t('DASHBOARD.RequiredRolesField'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (Array.isArray(this.editDashboardData.refreshInterval) && this.editDashboardData.refreshInterval.length === 0) {
        this.$vs.notify({
          title: this.$t('DASHBOARD.Attention'),
          text: this.$t('DASHBOARD.RequiredRefreshIntervalField'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    async addDashboard () {

      if (!this.validateAddForm()) {
        return
      }

      this.$vs.loading({type: 'default'})

      const dashboardRoles = []

      this.addDashboardData.roles.forEach(item => {
        dashboardRoles.push(item.hash)
      })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'add_application_dashboard',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard: {
      //         name: this.addDashboardData.name,
      //         description: this.addDashboardData.description,
      //         roles: dashboardRoles,
      //         refresh_interval: this.addDashboardData.refreshInterval.value
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'add_application_dashboard',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard: {
            name: this.addDashboardData.name,
            description: this.addDashboardData.description,
            roles: dashboardRoles,
            refresh_interval: this.addDashboardData.refreshInterval.value
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.getDashboards()
            this.addDashboardPopUpActive = false
            this.clearAddForm()
            this.$vs.notify({
              title: this.$t('DASHBOARD.SuccessOperation'),
              text: this.$t('DASHBOARD.DashboardAddedSuccessfully'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async updateDashboard () {

      if (!this.validateEditForm()) {
        return
      }

      this.$vs.loading({type: 'default'})

      const dashboardRoles = []

      this.editDashboardData.roles.forEach(item => {
        dashboardRoles.push(item.hash)
      })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'update_application_dashboard',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard: {
      //         hash: this.editDashboardData.hash,
      //         name: this.editDashboardData.name,
      //         description: this.editDashboardData.description,
      //         roles: dashboardRoles,
      //         refresh_interval: this.editDashboardData.refreshInterval.value
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'update_application_dashboard',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard: {
            hash: this.editDashboardData.hash,
            name: this.editDashboardData.name,
            description: this.editDashboardData.description,
            roles: dashboardRoles,
            refresh_interval: this.editDashboardData.refreshInterval.value
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.getDashboards()
            this.editDashboardPopUpActive = false
            this.clearEditForm()
            this.$vs.notify({
              title: 'Operação realizada!',
              text: 'Dashboard atualizado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async viewDashboardDetail (dashboardHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboard_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: dashboardHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_dashboard_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard_hash: dashboardHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.viewDashboardData.name = responseData.dashboard.name
              this.viewDashboardData.description = responseData.dashboard.description
              this.viewDashboardData.roles = responseData.dashboard.roles
              this.viewDashboardData.refreshInterval = this.refreshIntervalOptions.find(x => x.value === responseData.dashboard.refresh_interval)

              this.viewDashboardPopUpActive = true

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('DASHBOARD.Attetion'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getDashboardDetail (dashboardHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboard_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: dashboardHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_dashboard_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard_hash: dashboardHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.editDashboardData.hash = responseData.dashboard.hash
              this.editDashboardData.name = responseData.dashboard.name
              this.editDashboardData.description = responseData.dashboard.description
              this.editDashboardData.roles = responseData.dashboard.roles
              this.editDashboardData.refreshInterval = this.refreshIntervalOptions.find(x => x.value === responseData.dashboard.refresh_interval)

              this.editDashboardPopUpActive = true

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('DASHBOARD.Attetion'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    confirmDeleteRecord (rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('DASHBOARD.ConfirmDelete'),
        text: this.$t('DASHBOARD.ConfirmDeleteMessage'),
        accept: this.deleteRecord,
        acceptText: this.$t('DASHBOARD.Delete')
      })
    },
    async deleteRecord () {

      this.$vs.loading({ type: 'default' })

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_application_dashboard',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: this.rowHashToDelete
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'delete_application_dashboard',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard_hash: this.rowHashToDelete
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              // await fetch(this.$store.state.auth.api_url, {
              //   method: 'POST', headers: {"Content-Type": "application/json"},
              //   headers: {"Content-Type": "application/json"},
              //   body: JSON.stringify({
              //     command: 'get_application_user_mainmenu',
              //     parameters: {
              //       application_token: this.$store.state.auth.app_token,
              //       session_token: this.$store.state.auth.token
              //     }
              //   })
              // })
              await performFetch(this.$store.state.auth.api_url, {
                command: 'get_application_user_mainmenu',
                parameters: {
                  application_token: this.$store.state.auth.app_token,
                  session_token: this.$store.state.auth.token
                }
              })
                .then(async (response) => {
                  if (response.status === 200) {
                    await response.json().then(async (response) => {

                      await this.$store.dispatch('auth/buildApplicationMenu', response.mainmenu)

                      this.$store.dispatch('auth/reloadState')

                      this.rowHashToDelete = ''

                      await this.getDashboards()

                      this.$vs.notify({
                        title: this.$t('DASHBOARD.SuccessOperationDelete'),
                        text: this.$t('DASHBOARD.DashboardDeletedSuccessfully'),
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                      })
                    })
                  } else if (response.status == 401) {
                    this.$vs.loading.close()
                    setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                    this.$store.dispatch('auth/signOut')
                  } else {
                    this.$vs.loading.close()
                    this.$vs.notify({
                      title: this.$t('DASHBOARD.FailedOperation'),
                      text: this.$t('DASHBOARD.ModuleDeletedErrorMenuUpdate'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                  }
                })
                .catch((error) => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: this.$t('DASHBOARD.FailedOperation'),
                    text: this.$t('DASHBOARD.ModuleDeletedErrorMenuUpdate'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async getDashboardParameters () {
      this.$vs.loading({type: 'default'})
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboard_management_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_dashboard_management_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.rolesOptions = []
              this.allRolesOptions = []

              responseData.parameters.roles.forEach(item => {
                this.allRolesOptions.push({
                  hash: item.hash,
                  name: item.name
                })
                this.rolesOptions.push({
                  hash: item.hash,
                  name: item.name
                })
              })

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('DASHBOARD.Attetion'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getDashboards () {
      this.$vs.loading({type: 'default'})
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_dashboards',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_dashboards',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.dashboards = []

              if (responseData.dashboards.length > 0) {
                responseData.dashboards.forEach((item) => {

                  const dashboardRow = {
                    hash: item.hash,
                    name: item.name,
                    description: item.description,
                    refreshInterval: item.refresh_interval
                  }

                  this.dashboards.push(dashboardRow)
                })
              }

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('DASHBOARD.Attetion'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('DASHBOARD.Attetion'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  },
  async created () {
    await this.getDashboardParameters()
    await this.getDashboards()
  }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
